export default from './ProductSelect';



// WEBPACK FOOTER //
// ./src/components/Shop/ProductSelect/index.js